export default __webpack_public_path__ + "static/media/empty.a80e0c86.svg";